import FileUpload from 'vue-upload-component';

/**
 * Extended FileUpload component that overrides the getEntry method
 * to handle both File objects and FileEntry objects
 */
const ExtendedFileUpload = {
  extends: FileUpload,
  methods: {
    /**
     * Override getEntry method to support:
     * 1. File objects (from drag between tabs)
     * 2. FileEntry objects (from drag from desktop)
     * 3. DirectoryEntry objects (optional)
     */
    getEntry(entry, path = '') {
      return new Promise(resolve => {
        // Case 1: entry is already a File object (drag from another tab, etc.)
        if (entry instanceof File) {
          // eslint-disable-next-line no-console
          console.log('✅ ExtendedFileUpload: Entry is File object', entry.name);
          resolve([
            {
              size: entry.size,
              name: path + entry.name,
              type: entry.type,
              file: entry,
            },
          ]);
          return;
        }

        // Case 2: entry is a Blob (rare case)
        if (entry instanceof Blob && !(entry instanceof File)) {
          // eslint-disable-next-line no-console
          console.log('✅ ExtendedFileUpload: Entry is Blob object');
          resolve([
            {
              size: entry.size,
              name: `${path}blob`,
              type: entry.type,
              file: entry,
            },
          ]);
          return;
        }

        // Case 3: entry is a FileEntry (drag from desktop)
        if (entry.isFile) {
          // eslint-disable-next-line no-console
          console.log('✅ ExtendedFileUpload: Entry is FileEntry');
          entry.file(file => {
            resolve([
              {
                size: file.size,
                name: path + file.name,
                type: file.type,
                file,
              },
            ]);
          });
          return;
        }

        // Case 4: entry is a DirectoryEntry
        if (entry.isDirectory && this.dropDirectory) {
          // eslint-disable-next-line no-console
          console.log('✅ ExtendedFileUpload: Entry is DirectoryEntry');
          const files = [];
          const dirReader = entry.createReader();
          const readEntries = () => {
            dirReader.readEntries(entries => {
              const forEach = i => {
                if (
                  (!entries[i] && i === 0) ||
                  (this.maximum > 0 && files.length >= this.maximum)
                ) {
                  return resolve(files);
                }
                if (!entries[i]) {
                  return readEntries();
                }
                this.getEntry(entries[i], `${path}${entry.name}/`).then(
                  results => {
                    files.push(...results);
                    forEach(i + 1);
                  }
                );
              };
              forEach(0);
            });
          };
          readEntries();
          return;
        }

        // Case 5: Unknown type or directory when dropDirectory is false
        // eslint-disable-next-line no-console
        console.log('⚠️ ExtendedFileUpload: Entry type not recognized', entry);
        resolve([]);
      });
    },
  },
};

export default ExtendedFileUpload;
